var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWasteTypeLibrary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.197,
    height: 69.953,
    viewBox: "0 0 72.197 69.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mina_avfallstyper",
    "data-name": "Mina avfallstyper",
    transform: "translate(-13315.901 -2055.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26732",
    "data-name": "Group 26732",
    transform: "translate(13316.852 2056.816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26710",
    "data-name": "Group 26710",
    transform: "translate(18.258 27.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37355",
    "data-name": "Path 37355",
    d: "M17.152,0V36.745a4.278,4.278,0,0,1-4.276,4.278H-13.732a4.276,4.276,0,0,1-4.276-4.278V23.605",
    transform: "translate(18.008)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26711",
    "data-name": "Group 26711",
    transform: "translate(18.258 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37356",
    "data-name": "Path 37356",
    d: "M0,18.7v-34.06a4.276,4.276,0,0,1,4.276-4.276H30.884a4.275,4.275,0,0,1,4.276,4.276v8.292",
    transform: "translate(0 19.635)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26712",
    "data-name": "Group 26712",
    transform: "translate(27.675 63.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37357",
    "data-name": "Path 37357",
    d: "M0,0H16.324",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26713",
    "data-name": "Group 26713",
    transform: "translate(30.915 4.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37358",
    "data-name": "Path 37358",
    d: "M0,0H6.591",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26714",
    "data-name": "Group 26714",
    transform: "translate(40.629 4.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37359",
    "data-name": "Path 37359",
    d: "M0,0H.133",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26715",
    "data-name": "Group 26715",
    transform: "translate(47.858 12.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37360",
    "data-name": "Path 37360",
    d: "M10.333,4.4c2.612-3.335.76-8.472-3.446-8.981a6.292,6.292,0,0,0-.771-.047A6.327,6.327,0,0,0,.33-.848,6.322,6.322,0,0,0-5.453-4.624c-.035,0-.07,0-.105,0-4.526.072-6.878,5.5-4.086,9.057L.33,17.165Z",
    transform: "translate(10.849 4.624)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26716",
    "data-name": "Group 26716",
    transform: "translate(24.766 21.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37361",
    "data-name": "Path 37361",
    d: "M5.593,0,9.136,7.179l7.921,1.15-5.732,5.588,1.353,7.89L5.593,18.082l-7.085,3.725,1.353-7.89L-5.872,8.329l7.921-1.15Z",
    transform: "translate(5.872)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26717",
    "data-name": "Group 26717",
    transform: "translate(0 28.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37362",
    "data-name": "Path 37362",
    d: "M6.146,0l-12.6,21.823h25.2Z",
    transform: "translate(6.453)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWasteTypeLibrary);
export default __webpack_public_path__ + "static/media/Icon_wasteTypeLibrary.d7249bbb80491db5cc19bdb4ae74d9c5.svg";
export { ForwardRef as ReactComponent };